import { ImagesEntity } from '@galabid/gb-dashboard/shared/data-access-images'
import { LoaderTypeEnum } from 'libs/shared/utils/loader/src/lib/+state/loader.models'
import {
  BaseEventTicketPackageEntity,
  BaseEventTicketPackageImagesEntity,
} from 'libs/shared/models/event-tickets/event-ticket-packages.models'

export const eventTicketPackagesEntityName = 'EventTicketPackages'

/**
 * Interface for the 'EventTicketPackages' data
 */
export interface EventTicketPackageEntity extends BaseEventTicketPackageEntity {
  images: EventTicketPackageImagesEntity[]
  request_invoice_pending_tickets_total: number
  request_invoice_pending_total: number
  ticket_packages_sold: number
}

export type BulkUpdateEventTicketPackageFields = Partial<
  Pick<
    EventTicketPackageEntity,
    | 'hidden'
    | 'hide_number_available'
    | 'lock_status'
    | 'lock_message'
    | 'tax'
    | 'share_facebook'
    | 'share_twitter'
    | 'share_link'
    | 'request_invoice_allowed'
    | 'admin_purchase_notification_enabled'
    | 'max_ticket_packages_per_person'
  >
>

export interface BulkUpdateEventTicketPackagesPayload {
  ticket_packages: string[]
  ticket_package: BulkUpdateEventTicketPackageFields
}

export interface BulkDeleteEventTicketPackagesResponse {
  ticket_packages: string[]
}

export interface EventTicketPackageImagesEntity extends BaseEventTicketPackageImagesEntity {
  image: ImagesEntity
  order: number
  ticket_package: string
  uuid: string
}

export interface EventTicketPackageFilters {
  order?: string
  search?: string
}

export interface ReorderEventTicketPackagesResponse {
  start: number
  ticket_packages: string[]
}

export enum TicketTypeEnum {
  Individual = 'individual',
  Table = 'table',
}

export enum TicketPriceEnum {
  Paid = 'paid',
  Free = 'free',
}

export enum TicketLockEnum {
  None = 'none',
  Locked = 'locked',
}

export interface FormattedEventTicketPackageEntity extends EventTicketPackageEntity {
  [key: string]: unknown
}

export const EVENT_TICKET_PACKAGES_LOADER = {
  bulkUpdateEventTicketPackages: {
    id: 'bulkUpdateEventTicketPackages',
  },
  bulkDeleteEventTicketPackages: {
    id: 'bulkDeleteEventTicketPackages',
  },
  deleteEventTicketPackage: {
    id: 'deleteEventTicketPackage',
    message: 'LOADER.DELETING_TICKET',
  },
  reorderTickets: {
    id: 'reorderTickets',
    type: LoaderTypeEnum.Dialog,
    message: 'LOADER.REORDERING_TICKETS',
  },
}
